import React, { Fragment, useEffect, useState, useRef } from "react";
import "./style.scss";
import { textIdentifier } from "../../../../textIdentifier";

const ConfirmSuccessModal = ({ handleClose, userData, language }) => {
  return (
    <div className="confirm-main-container">
      <div className="header">
        {textIdentifier["download-report"][language]}
      </div>
      <div className="main-body">
        {`${textIdentifier["the-reports-are-being-generated-now-and-will-be-sent-to"][language]} ${userData.email} ${textIdentifier["soon"][language]}.`}
      </div>
      <div className="confirm-cta" onClick={handleClose}>
        {textIdentifier["okay,-sure"][language]}
      </div>
    </div>
  );
};

const ConfirmFailureModal = ({ handleClose, language }) => {
  return (
    <div className="confirm-main-container">
      <div className="error-header">
        <img src="/static/images/svg/error-icon.svg" />
        <div className="error-header--text"> {textIdentifier["error"][language]}</div>
      </div>
      <div className="main-body main-body--error">
        {
          textIdentifier[
            "the-report-cannot-be-downloaded-as-theres-no-registered-email-associated-with-your-account"
          ][language]
        }
      </div>
      <div className="confirm-cta" onClick={handleClose}>
        {textIdentifier["okay,-sure"][language]}
      </div>
    </div>
  );
};

const ConfirmDownloadReportModal = ({
  handleClose,
  downloadReportError,
  downloadReportSuccess,
  downloadReportLoading,
  userData,
  language,
}) => {
  if (!downloadReportLoading && (downloadReportError || downloadReportSuccess))
    return (
      <div className="confirm-modal-cnt">
        <div className="confirm-modal-body">
          {downloadReportSuccess ? (
            <ConfirmSuccessModal
              handleClose={handleClose}
              userData={userData}
              language={language}
            />
          ) : (
            <ConfirmFailureModal
              handleClose={handleClose}
              language={language}
            />
          )}
        </div>
      </div>
    );
  else return null;
};

export default ConfirmDownloadReportModal;
